module.exports = __webpack_public_path__ + "img/upload_bg_08.09439297.png";